import type { OrderLineItem, Resolution, Shop } from "../types";

type VariantOptionInfo = { name: string; value: string };
type VariantInfo = {
  inventory_quantity: number;
  inventoryPolicy?: string;
  selectedOptions?: VariantOptionInfo[];
};
type ProductInfo = { variants: VariantInfo[] };
export type VariantCollection = { products: ProductInfo[] };

function isRealVariant(v: VariantInfo): boolean {
  return (v.selectedOptions ?? []).some((o) => o.value !== "Default Title");
}

function hasAlternativeVariants(
  collection: VariantCollection,
  minimalStock: number,
): boolean {
  return collection.products.some((p) =>
    p.variants.some(
      (v) =>
        isRealVariant(v) &&
        (v.inventoryPolicy === "CONTINUE" || v.inventory_quantity > minimalStock),
    ),
  );
}

export function getAvailableResolutions(
  shop: Shop,
  lineItem: OrderLineItem,
  variantCollection?: VariantCollection | null,
): Resolution[] {
  const shopAny = shop as any;
  const lineItemAny = lineItem as any;

  const nonReturnable: string[] = shopAny.preferences?.nonReturnableItems ?? [];
  if (nonReturnable.includes(lineItemAny.product_id)) return [];

  const available: Resolution[] = ["refund"];

  const exchangeEnabled =
    shopAny.exchange?.activated && shopAny.exchange?.available;

  if (exchangeEnabled) {
    const minimalStock: number = shopAny.exchange?.minimalStock ?? 0;
    const variantsAvailable =
      !variantCollection ||
      (variantCollection.products.length > 0 &&
        hasAlternativeVariants(variantCollection, minimalStock));

    if (variantsAvailable) {
      available.push("exchange");
    }
  }

  if (shopAny.discount?.activated && shopAny.discount?.available) {
    available.push("discount");
  }

  if (exchangeEnabled && shopAny.exchange?.exchangeWithOtherArticles) {
    available.push("exchange-credit");
  }

  return available;
}
